import React, { memo, useMemo } from 'react'
import { HighlightMark } from '../styles'
import { highlightText } from '../../../Utils/search/search.utils'

type HighlightedTextProps = {
  text: string
  query: string
}

export const HighlightedText = memo<HighlightedTextProps>(({ text, query }) => {
  const parts = useMemo(() => highlightText(text, query), [text, query])

  if (parts.length === 1 && !parts[0].isMatch) {
    return <>{text}</>
  }

  return (
    <>
      {parts.map((part, index) =>
        part.isMatch ? (
          <HighlightMark key={index}>{part.text}</HighlightMark>
        ) : (
          <React.Fragment key={index}>{part.text}</React.Fragment>
        )
      )}
    </>
  )
})

HighlightedText.displayName = 'HighlightedText'
